__turbopack_context__.v({
  "amount": "product-purchase-module-scss-module__Ax64UG__amount",
  "badge": "product-purchase-module-scss-module__Ax64UG__badge",
  "bonus": "product-purchase-module-scss-module__Ax64UG__bonus",
  "chips": "product-purchase-module-scss-module__Ax64UG__chips",
  "parts": "product-purchase-module-scss-module__Ax64UG__parts",
  "picker": "product-purchase-module-scss-module__Ax64UG__picker",
  "popover": "product-purchase-module-scss-module__Ax64UG__popover",
  "popover-head": "product-purchase-module-scss-module__Ax64UG__popover-head",
  "preorder": "product-purchase-module-scss-module__Ax64UG__preorder",
  "price": "product-purchase-module-scss-module__Ax64UG__price",
  "question": "product-purchase-module-scss-module__Ax64UG__question",
  "root": "product-purchase-module-scss-module__Ax64UG__root",
  "start": "product-purchase-module-scss-module__Ax64UG__start",
  "title": "product-purchase-module-scss-module__Ax64UG__title",
  "x": "product-purchase-module-scss-module__Ax64UG__x",
});
